import { render, staticRenderFns } from "./GuestBannerSidebar.vue?vue&type=template&id=7166dafc&"
import script from "./GuestBannerSidebar.vue?vue&type=script&lang=js&"
export * from "./GuestBannerSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports